/**
 * Notizen — Inventar 2.0, S7a.
 *
 * The same card chrome the S6b fact cards use, but written out here instead of
 * reusing `DetailCard`: the S6a net reaches the textarea through
 * `screen.getByRole("heading", { name: "Notizen" }).parentElement`, so the
 * <h2> has to stay a DIRECT child of the element that also holds the textarea.
 * `DetailCard` puts its heading inside a header row (it needs one for the
 * action slot), which would re-point that parent at a box containing no
 * controls. This card has no action slot, so the header row buys nothing —
 * dropping it keeps D22/E25 valid without weakening them.
 *
 * Behaviour is untouched: one textarea bound to `notesDraft`, one button that
 * calls `saveNotes`. No autosave, no dirty tracking, no leave confirmation —
 * none of that exists today and S7a does not invent it.
 */
import React from "react";

export default function InventoryNotesCard({
  notesDraft,
  onChangeDraft,
  onSave,
  saving,
  error,
}) {
  return (
    <section className="rounded-[10px] border border-border bg-card p-4" aria-label="Notizen">
      <h2 className="m-0 text-[10px] font-bold uppercase tracking-[0.09em] text-muted-foreground">
        Notizen
      </h2>
      {error ? <p className="m-0 mt-2 text-[13px] font-medium text-destructive">{error}</p> : null}
      <textarea
        value={notesDraft}
        onChange={(e) => onChangeDraft(e.target.value)}
        rows={3}
        aria-label="Notizen zum Artikel"
        className="mt-3 w-full resize-y rounded-[8px] border border-border bg-muted px-3 py-2 text-[13px] font-medium text-foreground outline-none transition-colors focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring"
      />
      <div className="mt-3 flex justify-end">
        <button
          type="button"
          disabled={saving}
          onClick={onSave}
          className="rounded-[8px] bg-primary px-4 py-2 text-[12.5px] font-semibold text-primary-foreground transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
        >
          {saving ? "…" : "Notizen speichern"}
        </button>
      </div>
    </section>
  );
}
